import { TableFilterRange } from 'components'

import { ItemCategoryFilter } from '../elements/ItemCategoryFilter'

export const itemsFilterOptions = [
  { value: 'categoryId', label: 'Category', component: <ItemCategoryFilter key="categoryId" /> },
  { value: 'price', label: 'Price Range', component: <TableFilterRange key="price" name="price" /> },
]
